// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/screens/Screen4/styles.scss
// module id = 387
// module chunks = 0